// HELPER FUNCTIONS
// ****************

var ready = function(fn) {
  if (typeof fn !== 'function') { 
    return; 
  }
  if (document.readyState === 'complete') {
    return fn();
  }
  document.addEventListener('DOMContentLoaded', fn, false);
};

function hasClass(element, cls) {
    return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
}

function inStore(id, list) {
  for (var i = 0; i < list.length; i++) {
    if (list[i] && id === list[i].id) {
      return i;
    }
  }
  return -1;
}

var muteLinks = function (event) {
  event.preventDefault(event);
  event.stopPropagation(event);
};


// HELPER FUNCTIONS - FRONT PAGE
// *****************************

// GLOBAL VARIABLES
// ****************

var ylymom_stored_items;

ready(function() {
  // SETUP MAIN ELEMENTS
  var assets = document.querySelectorAll('.JS_addToPDF');
  var pdfNavButton = document.querySelector('.JS_pdfNavButton');
  var pdfCount = document.querySelector('.JS_pdfNavCount');
  var slideViewButton = document.querySelector('.JS_addToPDF-SlideView');

  // check if items are stored for pdf
  ylymom_stored_items = JSON.parse(localStorage.getItem('ylymom_stored_items'));
  if (!ylymom_stored_items) {
    ylymom_stored_items = [];
  }

  // display PDF button in main navigation
  if (ylymom_stored_items.length !== 0) {
    pdfNavButton.style.display = 'flex';
    pdfCount.innerHTML = ylymom_stored_items.length;
  }

  // set asset-button class based on wheter displayed asset is stored
  [].forEach.call(assets, function(elem, i) {
    var index = inStore(elem.dataset.id, ylymom_stored_items);
    if (index >= 0) {
      elem.classList.add('JS_storedForPdf');
    }
  });

  

  // asset-button event listener
  var addOrSplice = function(ev) {
    this.classList.toggle('JS_storedForPdf');
    if (hasClass(this, 'JS_storedForPdf')) {
      var index = inStore(this.dataset.id, ylymom_stored_items);
      if (index <= 0) {
        ylymom_stored_items.push({ id: this.dataset.id, src: this.dataset.src });
      }
    } else {
      var index = inStore(this.dataset.id, ylymom_stored_items);
      ylymom_stored_items.splice(index, 1);
    }
    localStorage.setItem('ylymom_stored_items', JSON.stringify(ylymom_stored_items));
    if (ylymom_stored_items.length === 0) {
      pdfNavButton.style.display = 'none';
    } else {
      pdfNavButton.style.display = 'flex';
    }
    pdfCount.innerHTML = ylymom_stored_items.length;
  };
  
  // add event listener to every assets button
  [].forEach.call(assets, function(elem, index) {
    elem.addEventListener('click', addOrSplice);
  });


// RENDER HELPER FUNCTION
// **********************

  var createListItem = function(item) {
    var li = document.createElement('li');
    var buttonHolder = document.createElement('div');
    var addButton = document.createElement('span');
    var removeButton = document.createElement('span');
    var a = document.createElement('a');
    var image = new Image();

    li.classList.add('ContentGrid-Item', 'ContentGrid-Item--1of4');
    buttonHolder.classList.add('Button', 'Button--addToPDF', 'JS_addToPDF');
    addButton.classList.add('add');
    removeButton.classList.add('remove');
    a.href = '#';

    image.src = item.src;
    buttonHolder.dataset.id = item.id;

    buttonHolder.appendChild(addButton);
    buttonHolder.appendChild(removeButton);

    a.appendChild(image);

    li.appendChild(buttonHolder);
    li.appendChild(a);

    return li;
  };


// RENDER 
// ******

  if (document.querySelector('.page.pdf') !== null) {

    var container = document.querySelector('.ContentGrid');

    if (ylymom_stored_items && ylymom_stored_items.length > 0) {
      for (var i = 0; i < ylymom_stored_items.length; i++) {
        if (ylymom_stored_items[i] && ylymom_stored_items[i].src) {
          var l_item = createListItem(ylymom_stored_items[i]);

          l_item.addEventListener('click', function() {
            var l_index = inStore(this.dataset.id, ylymom_stored_items);
            ylymom_stored_items.splice(l_index, 1);
            this.remove();
            localStorage.setItem("ylymom_stored_items", JSON.stringify(ylymom_stored_items));
            pdfCount.innerHTML = ylymom_stored_items.length;
          });

          container.append(l_item);
        }
      }
    }

    var genButton = document.querySelector('.js_generatePdf');
    var dlButton = document.querySelector('#js_dlPdf');
    var dlAssets = document.querySelector('#js_assets');
    var formPdf = document.querySelector('.JS_pdfForm');

    genButton.addEventListener('click', function() {
      this.classList.add('u-none');
      var assetsIds = "";
      for (var i=0;i<ylymom_stored_items.length;i++) {
        if (assetsIds.length>0)
        {
          assetsIds +=',';
        }
        assetsIds +=ylymom_stored_items[i].id;
      }
      dlAssets.value = assetsIds;
      formPdf.classList.remove('u-none');
    });
  }

  if (document.querySelector('body.home') !== null || document.querySelector('body.tax-media_category') !== null) {
    var contentContainer = document.querySelector('.ContentGrid');
    var infScroll = new InfiniteScroll( contentContainer, {
      path: '.next',
      append: '.ContentGrid-Item.ContentGrid-Item--1of3',
      history: false,
    });
  }

});



